<template>
    <div>

        <rkm-row>

            <rkm-col
                class="mb-2"
                cols="12"
            >

                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                >
                    <template v-if="!exames.find(item => item.selecionado)">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>
            </rkm-col>

            <rkm-col
                class="mb-2"
                cols="12"
            >
                <rkm-table
                    :items="exames"
                    :fields="fields"
                    hide-filters
                    sort-by="data"
                    :sort-compare="sortCompare"
                    hide-pagination
                >

                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                        @change="handleExames()"
                    />
                </template>

                    <template v-slot:cell(actions)="{ item }">

                        <rkm-button
                            color="danger"
                            small
                            title="Descartar exame"
                            @click.stop="descartarAmbulatorioAtendimento(item)"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>

                        <rkm-button
                            color="primary"
                            small
                            title="Reagendar exame"
                            @click.stop="agendarAmbulatorioAtendimento(item)"
                        >
                            <rkm-icon icon="clone" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    <ModalPermissao
        ref="RkmModalPermissao"
        @saveModal="saveModal"
        :origem="origem"
    />

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

import ModalPermissao from '@/components/exame-laboratorial/agendamento-exame/tabs/cadastro/components/permissao/Modal'

//Enums
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import motivo from '@/enums/exame-laboratorial/motivo'

// Moment.
import moment from 'moment'

export default {
    components: { ModalPermissao },
    computed: {
        fields() {
            const fields = [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: "exameNome",
                    label: "Exame",
                    sortable: true
                },
                {
                    key: "data",
                    label: "Data da solicitação",
                    sortable: true
                },
                {
                    key: "profissionalNome",
                    label: "Profissional solicitante",
                    sortable: true
                },
                {
                    key: "unidade",
                    label: "Unidade",
                    sortable: true
                },
                {
                    key: "infraestrutura",
                    label: "Local de atendimento",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ]

            return fields
        },
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }
    },
    data() {
        return {
            modalPacienteId: null,
            reagendar: null,
            item: null,
            examesBloqueado: [],
            autoriza: false,
            verifyExame: false,
            supervisorId: null,
            enums: {
                statusAgendamento,
                motivo
            },
            exameBloqueado: {
                exameId: null,
                pacienteId: null,
                valor: null,
                motivoId: null,
            },
            origem: 'ambulatorio',
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleStatus(agendamento, item) {

            const exame = {
                ...agendamento,
                exames: [item]
            };

            this.modalPacienteId = agendamento.pacienteId
            this.reagendar = exame

            this.showConfirmation(
                `Deseja reagendar a coleta para o exame/grupo <strong>${item.exameGrupoNome}</strong>?`,
                async () => this.$nextTick().then(() => this.$refs.ModalAgendamentoExameLaboratorial.open())
            )
        },
        handleReagendar(agendamento) {

            const exame = this.clone(agendamento)

            this.modalPacienteId = exame.pacienteId
            this.reagendar = exame
            this.reagendar.exames = exame.exames.filter(exame => exame.statusId != this.enums.statusAgendamento.REALIZADO
                && exame.statusId != this.enums.statusAgendamento.AGENDADO
            )

            this.showConfirmation(
                `Deseja reagendar a coleta para o exames não realizados do protocolo <strong>${exame.agendamentoNumero}</strong>?`,
                async () => this.$nextTick().then(() => this.$refs.ModalAgendamentoExameLaboratorial.open())
            )
        },
        selecionarTodos(){

            if(this.exames.find(item => item.selecionado)){

                this.exames.map(item => (item.selecionado = false))
                this.$emit('handleSelecionado', false)
            } else {

                this.exames.map(item => (item.selecionado = true))
                this.$emit('handleSelecionado', true)
            }
        },
        handleExames() {

            if(this.exames.find(item => item.selecionado)){

                this.$emit('handleSelecionado', true)
            } else {

                this.$emit('handleSelecionado', false)
            }
        },
        agendarAmbulatorioAtendimento(item) {

            this.item = item

            if (!item.exameSiglaExame || !item.exameGrupoTipoId) {
                this.showAlert(
                    'Para selecionar este exame, é necessário que todas as informações obrigatórias estejam preenchidas. Acesse Parametrização > Exame e preencha as informações.',
                    'Atenção'
                )
                return
            }

            if (item.exameSenhaSupervisor) {
                if (!this.autoriza && !this.verificaAutorizacao) {
                    this.exigirAutorizacao(`O exame <strong>${item.exameNome}</strong> requer autorização de supervisor para ser incluído.`)
                    return
                }
                if (!this.autoriza) {
                    this.supervisorId = this.agendamento?.supervisorId
                }
            }

            if (!item.examePermiteRepeticao) {



                const { bloqueado: validadeBloqueada, mensagem } = this.verificarValidadeExame(item)

                if (validadeBloqueada) {
                    if (!this.autoriza && !this.verificaAutorizacao) {
                        this.exigirAutorizacao(mensagem)
                        return
                    }
                    if (!this.autoriza) {
                        this.supervisorId = this.agendamento?.supervisorId
                    }
                    this.registrarExameBloqueado(this.enums.motivo.PRAZO_VALIDADE, item)
                }

                const { bloqueado: limiteBloqueado, mensagem: mensagemLimite } = this.verificarLimiteAnual(item)

                if (limiteBloqueado) {
                    if (!this.autoriza && !this.verificaAutorizacao) {
                        this.exigirAutorizacao(mensagemLimite)
                        return
                    }
                    if (!this.autoriza) {
                        this.supervisorId = this.agendamento?.supervisorId
                    }
                    this.registrarExameBloqueado(this.enums.motivo.LIMITE_ANUAL, item)
                }
            }

            this.$emit('agendarAmbulatorioAtendimento', { ...item, supervisorId: this.supervisorId })
        },
        saveExameBloqueado(motivo, exame) {

            if (!exame) return

            const exameExistente = this.examesBloqueado.find(e => e.exameId === exame.id);

            if (!exameExistente) {

                this.repositories.agendamento.saveExameBloqueado(this.prepareData(motivo, exame))
                    .then(({ data }) => {

                        this.examesBloqueado.push(data);
                    })
                    .catch(this.handleError)
                    .finally()
            }
        },
        saveModal(supervisorId) {
            this.supervisorId = supervisorId
            this.autoriza = true
            this.agendarAmbulatorioAtendimento(this.item)
        },
        prepareData(motivo, exame) {

            const exameBloqueado = this.clone(this.exameBloqueado)

            exameBloqueado.pacienteId = this.paciente.id
            exameBloqueado.exameId = exame.exameId
            exameBloqueado.valor = exame.exameValorSigtap ? exame.exameValorServicoAmbilatorial : exame.exameValor
            exameBloqueado.motivoId = motivo

            return this.camelObjectKeysToSnakeRecursive(exameBloqueado)
        },
        verificarValidadeExame(exame) {

            if (!exame.validade) {
                return { bloqueado: false }
            }

            let msgExame = ''
            let bloqueado = false

            this.data.model.agendamentos
                .filter(e =>
                    e.pacienteId == this.paciente.id &&
                    e.agendamentoId !== this.agendamento?.agendamentoId
                )
                .forEach(exameIncluido => {

                    const exameFind = exameIncluido.incluido.find(m =>
                        m.codigo == exame.exameCodigo &&
                        m.statusId !== this.enums.statusAgendamento.CANCELADO
                    )

                    if (!exameFind) return

                    const statusIgnorados = [
                        this.enums.statusAgendamento.FALTOU,
                        this.enums.statusAgendamento.NAO_REALIZADO,
                        this.enums.statusAgendamento.AGENDADO,
                        this.enums.statusAgendamento.DUPLICIDADE,
                        this.enums.statusAgendamento.OUTROS
                    ]

                    if (statusIgnorados.includes(exameFind.statusId)) return

                    const validadeFinal = moment(exameIncluido.data)
                        .add(exame.validade, 'days')

                    const hoje = moment(this.data.form.dataAtual, 'DD/MM/YYYY')

                    if (validadeFinal.isAfter(hoje)) {

                        bloqueado = true

                        const dataFormatada = moment(exameIncluido.data).format('DD/MM/YYYY')
                        const hora = exameIncluido.horaInicial

                        msgExame += msgExame
                            ? `, <strong>${dataFormatada}</strong> às <strong>${hora}</strong>`
                            : `O paciente já possui agendamento para o exame <strong>${exame.exameNome}</strong>
                            dentro do prazo de validade na(s) data(s):
                            <strong>${dataFormatada}</strong> às <strong>${hora}</strong>`
                    }
                })

            return {
                bloqueado,
                mensagem: msgExame
            }
        },
        verificarLimiteAnual(item) {

            const quantidadeMaxima = item.exameQuantidadeMaxima ?? item.exameQuantidadeMaximaExecucao

            if (quantidadeMaxima === null || quantidadeMaxima === undefined || quantidadeMaxima === 9999) {
                return { bloqueado: false }
            }

            let quantidadeExameAgendado = 0

            this.data.model.agendamentos
                .filter(e => e.pacienteId == this.paciente.id && e.agendamentoId !== this.agendamento?.agendamentoId)
                .forEach(exameIncluido => {
                    if (exameIncluido.incluido.find(m => m.codigo == item.exameCodigo)) {
                        quantidadeExameAgendado++
                    }
                })

            if (quantidadeMaxima <= quantidadeExameAgendado) {
                return {
                    bloqueado: true,
                    mensagem: `O paciente já atingiu o limite anual para o exame <strong>${item.exameNome}</strong>.`
                }
            }

            return { bloqueado: false }
        },
        exigirAutorizacao(mensagem) {

            const msg = `${mensagem}.<br><br>
                Para continuar é necessário informar os dados do supervisor. Deseja continuar?`

            const confirm = async () => {
                this.$refs.RkmModalPermissao.open()
                return false
            }

            this.showConfirmation(msg, confirm, async () => {})
        },
        registrarExameBloqueado(motivo, exame) {

            if (!exame) return

            const existe = this.examesBloqueado
                .some(e => e.exameId === exame.id)

            if (existe) return

            this.repositories.agendamento
                .saveExameBloqueado(this.prepareData(motivo, exame))
                .then(({ data }) => {
                    this.examesBloqueado.push(data)
                })
                .catch(this.handleError)
        },
        descartarAmbulatorioAtendimento(item) {

            this.$emit('descartarAmbulatorioAtendimento', item)
        }
    },
    props: {
        paciente: { type: Object, required: true},
        exames: { type: Array, required: true},
        agendamento: { type: Object, required: false},
        data: { type: Object, required: false},
        verificaAutorizacao: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
.font-13 {
    font-size: 13px!important;
}
h4 {
    font-size: 20px!important;
    font-weight: 600!important;
}
</style>